import { Check, ArrowRight } from "lucide-react";

const plans = [
  {
    id: "pose-seule",
    name: "Pose seule",
    eyebrow: "Main d'œuvre uniquement",
    price: "80€",
    suffix: "à partir de",
    items: [
      "Vous fournissez vos composants",
      "Montage complet & câblage soigné",
      "Stress test et validation des températures",
      "Devis fixe et prix garanti",
    ],
  },
  {
    id: "cle-en-main",
    name: "PC clé en main",
    eyebrow: "Configuration sur mesure",
    price: "Sur devis",
    suffix: "selon votre budget",
    featured: true,
    items: [
      "Sélection complète des composants",
      "Optimisation selon votre usage",
      "Livraison soignée à domicile",
      "Tests + installation Windows incluse",
    ],
  },
  {
    id: "nettoyage",
    name: "Nettoyage PC gamer",
    eyebrow: "Maintenance & optimisation",
    price: "30€",
    suffix: "à partir de",
    items: [
      "Démontage et dépoussiérage complet",
      "Pâte thermique CPU & GPU remplacée",
      "Nettoyage des filtres et du boîtier",
      "Optimisation Windows + drivers",
      "Test de températures avant/après",
    ],
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="absolute inset-x-0 top-0 h-[1px] bg-gradient-to-r from-transparent via-violet-500/50 to-transparent" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // Tarifs
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Des prix clairs, sans surprise.
          </h2>
          <p className="mt-4 text-zinc-400">
            Chaque devis est gratuit, écrit, et garanti. Pas de frais cachés,
            pas de changement de prix sur place.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {plans.map((p) => (
            <div
              key={p.id}
              data-testid={`pricing-card-${p.id}`}
              className={`reveal relative rounded-2xl p-8 sm:p-10 transition-all hover:-translate-y-1 ${
                p.featured
                  ? "gradient-border shadow-violet"
                  : "border border-white/10 bg-zinc-900/40 hover:border-violet-400/40"
              }`}
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
                {p.eyebrow}
              </p>
              <h3 className="mt-2 font-display text-2xl font-bold">{p.name}</h3>

              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display text-5xl font-extrabold text-white">
                  {p.price}
                </span>
                <span className="text-sm text-zinc-500">{p.suffix}</span>
              </div>

              <ul className="mt-8 space-y-3">
                {p.items.map((i) => (
                  <li key={i} className="flex items-start gap-3 text-sm">
                    <Check className="h-4 w-4 mt-0.5 text-violet-400 flex-none" />
                    <span className="text-zinc-300">{i}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                data-testid={`pricing-cta-${p.id}`}
                className={`mt-10 inline-flex w-full items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold transition-all ${
                  p.featured
                    ? "bg-violet-600 hover:bg-violet-500 text-white shadow-violet"
                    : "border border-white/10 bg-white/5 hover:bg-white/10 text-white"
                }`}
              >
                Obtenez votre devis en 24h
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
